// extracted by mini-css-extract-plugin
export default {"login_form":"login_login_form__gqlxi","logo_div":"login_logo_div__MRCvo","form_input":"login_form_input__UCo3R","main_button":"login_main_button__FSfMY"};